import { useContext, useMemo } from "react";
import {
  TranslationContext,
  TranslateParams,
  TranslateOptions,
} from "@/contexts/TranslationProvider";

export function useTranslation(parentKey?: string) {
  const context = useContext(TranslationContext);

  if (!context) {
    throw new Error(
      "useTranslations must be used within a TranslationProvider",
    );
  }

  const { t } = context;

  return useMemo(() => {
    return (
      key: string,
      params?: TranslateParams,
      options?: TranslateOptions,
    ) => {
      const normalizedKey = parentKey ? `${parentKey}.${key}` : key;
      return t(normalizedKey, params, options);
    };
  }, [t, parentKey]);
}
